export const dateRangeEnum = {
  CREATE: 'create_time',
  REGISTER: 'register_date',
  EXECUTION: 'execution_date',
};
